import { Audience, NotificationsRes } from '@/api/types/notificationsType';

const ADMIN_TYPE_TO_AUDIENCE: Record<string, Audience> = {
  ADMIN: Audience.Admin,
  SUPER_ADMIN: Audience.SuperAdmin,
  ACADEMIC_SUPERVISOR: Audience.ACADEMIC_SUPERVISOR,
  PROGRAM_HEAD: Audience.PROGRAM_HEAD,
  SYSTEM_ADMIN: Audience.SystemAdmin,
};

export const filterNotificationsByAudience = (
  notifications: NotificationsRes[],
  adminType?: string
): NotificationsRes[] => {
  if (!adminType) {
    return notifications;
  }

  const currentAudience = ADMIN_TYPE_TO_AUDIENCE[adminType];

  if (!currentAudience) {
    return notifications;
  }

  return notifications.filter((notification) => {
    if (!notification.audience?.length) {
      return true;
    }

    return notification.audience.includes(currentAudience);
  });
};

export const filterNotificationsByTargetAdmin = (
  notifications: NotificationsRes[],
  adminId?: number
): NotificationsRes[] => {
  if (!adminId) {
    return notifications;
  }

  return notifications.filter((notification) => {
    // API uses root target_admin_id for "only this admin" delivery.
    // Do not use params.admin_id — that is the subject admin it gets sent to all audience .
    const targetAdminId = notification.target_admin_id ?? null;

    if (targetAdminId == null) {
      return true;
    }

    return targetAdminId === adminId;
  });
};
